/**
 *
 * @description: 睿远基金
 *
 */
import store from '@/store';
import router from '@/router';
import { isBuild } from '@/apis/host';
import { customLink, ryjj_open_postMessage } from '@/utils/api';
import { BRM_URL_HOST } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'ryjj';
const comein_channel = isBuild ? 'd44682c4-5b4a-487d-9d31-a9b907ebd1ff' : 'bfb902a4-194a-40eb-b1a4-977d2e613d90';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'ryjj';

// 睿远基金Bridge类 - 使用默认实现，不需要重写方法
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);
  }

  // 路演列表点击路演事件跳转路演厅事件
  goRoadshowDetail(params) {
    store.dispatch('enterRoadshowLiveAction', {
      ...params,
      callback: (path) => {
        const comein = sessionStorage.getItem('COMPANY');
        if (comein && comein === 'comein') {
          customLink(path);
        } else {
          ryjj_open_postMessage(path);
        }
      }
    });
  }

  // 跳转纪要详情页
  goSummaryDetail(payload) {
    const path = router.resolve(payload);

    const comein = sessionStorage.getItem('COMPANY');
    if (comein && comein === 'comein') {
      customLink(path.href);
    } else {
      const url = `${BRM_URL_HOST}${path.href}`;
      ryjj_open_postMessage(url);
    }
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
